/*******************************************************************************
 * @ngdoc    object
 * @name     csm.books.services.NewBooksData.type:JournalItem
 * @constructor
 * @param {object=} info  Properties to assign.
 * @description
 * Journal item.
 *******************************************************************************/
JournalItemConfig.$inject = ['TypeFactoryProvider'];
/* @ngInject */ export function JournalItemConfig(TypeFactoryProvider) {
  TypeFactoryProvider.addType({
    name: 'NewBooksData.JournalItem',
    $type: 'csm.booksdb.data.JournalItem, CSMBooksDBCS',
    prototype:  function($injector) {
      return Object.defineProperties(
        {
          id: 0, // Line Item ID.
          ledgerItemID: 0, // Ledger Item ID.
          accountID: 0, // Account ID.
          classID: 0, // Class ID.
          description: null, // Description.
          dr: 0, // Debit Amount.
          cr: 0, // Credit Amount.
          changeToBalance: 0 // Change to Balance.
        },
        {
          setValue: { value: $injector.invoke(setValue) }
        }
      );
    }
  });
}

/***************************************************************************
 * setValue */
/**
 * Sets Dr/Cr values from the input and normalizes so that only one is not
 * zero and always positive.
 *
 * @param  {number} dr  Debit Amount
 * @param  {number} cr  Credit Amount
 ***************************************************************************/
setValue.$inject = ['Tools'];
/* @ngInject */ function setValue(Tools) {
  return function (dr, cr) {
    this.dr = Tools.roundMoney(dr > cr ? dr - cr : 0);
    this.cr = Tools.roundMoney(cr > dr ? cr - dr : 0);
  };
}
